import React from "react";
import Letop from "../allpages/Letop";
import Tip from "../allpages/Tip";

export default () => (
  <div>
    <p>
      <Letop>
        Alle onderstaande vormen worden gemaakt met de{" "}
        <a href="/spqr/leerdoelen/8b">praesensstam</a>.
      </Letop>
    </p>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={4}>indicativus</th>
        </tr>
        <tr>
          <th className="col" />
          <th rowSpan={2}>praesens</th>
          <th rowSpan={2}>imperfectum</th>
          <th colSpan={2}>futurum</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>a-/e-groep</th>
          <th>i-/mk-groep</th>
        </tr>
        <tr>
          <th className="col">1e ev.</th>
          <td>
            {" "}
            <Tip tip="bij a-stammen<br/>valt de a- weg">or</Tip>
          </td>
          <td>ba–r</td>
          <td>b–or</td>
          <td>a–r</td>
        </tr>
        <tr>
          <th className="col">2e ev.</th>
          <td>ris</td>
          <td>ba–ris</td>
          <td>be–ris</td>
          <td>e–ris</td>
        </tr>
        <tr>
          <th className="col">3e ev.</th>
          <td>tur</td>
          <td>ba–tur</td>
          <td>bi–tur</td>
          <td>e–tur</td>
        </tr>
        <tr>
          <th className="col">1e mv.</th>
          <td>mur</td>
          <td>ba–mur</td>
          <td>bi–mur</td>
          <td>e–mur</td>
        </tr>
        <tr>
          <th className="col">2e mv.</th>
          <td>mini</td>
          <td>ba–mini</td>
          <td>bi–mini</td>
          <td>e–mini</td>
        </tr>
        <tr>
          <th className="col bor-bot">3e mv.</th>
          <td className="bor-bot">ntur</td>
          <td className="bor-bot">ba–ntur</td>
          <td className="bor-bot">bu–ntur</td>
          <td className="bor-bot">e–ntur</td>
        </tr>
        <tr>
          <th />
          <td>
            <em>ik word gegeten</em>
          </td>
          <td>
            <em>ik werd gegeten</em>
          </td>
          <td colSpan={2}>
            <em>ik zal worden gegeten</em>
          </td>
        </tr>
      </table>
    </div>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th>conjunctivus</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>praesens</th>
        </tr>
        <tr>
          <th className="col">1e ev.</th>
          <td>
            <Tip tip="bij a-stammen<br/>is dit een e-">a</Tip>–r
          </td>
        </tr>
        <tr>
          <th className="col">2e ev.</th>
          <td>
            {" "}
            <Tip tip="bij a-stammen<br/>is dit een e-">a</Tip>–ris
          </td>
        </tr>
        <tr>
          <th className="col">3e ev.</th>
          <td>
            {" "}
            <Tip tip="bij a-stammen<br/>is dit een e-">a</Tip>–tur
          </td>
        </tr>
        <tr>
          <th className="col">1e mv.</th>
          <td>
            {" "}
            <Tip tip="bij a-stammen<br/>is dit een e-">a</Tip>–mur
          </td>
        </tr>
        <tr>
          <th className="col">2e mv.</th>
          <td>
            {" "}
            <Tip tip="bij a-stammen<br/>is dit een e-">a</Tip>–mini
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">3e mv.</th>
          <td className="bor-bot">
            {" "}
            <Tip tip="bij a-stammen<br/>is dit een e-">a</Tip>–ntur
          </td>
        </tr>
        <tr>
          <th />
          <td>
            <em>ik word gegeten</em>
          </td>
        </tr>
      </table>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/onv-pass-43.js